import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import EntityStateUpdater from 'component/EntityStateUpdater';

import Loader from 'components/layout/Loader';
import Data from 'components/Data';
import Entity from 'components/Entity';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';
import FormInputPassword from 'components/forms/FormInputPassword';
import FormErrors from 'components/forms/FormErrors';

import { entityMetaMapping } from 'js/constants';

class DataPushForm extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();
    // if we get data push config data from the outside, we can pass it on to our data entity
    // if not, set some defaults
    this.entity.setData(
      props.dataPush || {
        auth: 'basic',
        event: 'create',
        endpoint: 'https://',
      }
    );
    if (props.meta[entityMetaMapping.dataPush] !== undefined && !props.meta[entityMetaMapping.dataPush].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.dataPush);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = () => {
    const { meta } = this.props;

    if (
      meta[entityMetaMapping.dataPush] !== undefined &&
      !meta[entityMetaMapping.dataPush].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.dataPush);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  formSubmit = e => {
    e.preventDefault();

    this.setState(
      prevState => ({ entity: prevState.entity.validate() }),
      () => {
        if (this.state.entity.isValid) {
          this.props.onSubmit(this.state.entity.processedData);
        }
      }
    );
  };

  render() {
    const {
      intl: { messages },
      formStatus,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    return (
      <Row>
        <Data dataName="dataPush" /> {/* fetch meta data */}
        <Col xs={12}>
          <FormErrors formStatus={formStatus} />

          {entityLoaded ? (
            <form method="post" onSubmit={this.formSubmit}>
              <div class="panel panel-transparent">
                <p className="form-group-title">{messages.formGroup.basic_information}</p>
                <div class="form-group-attached">
                  <FormAutocomplete
                    name="entity"
                    label={messages.entity}
                    value={entity.getEntity()}
                    meta={entity.getEntityMetaInformation()}
                    validation={entity.getEntityValidationResult()}
                    onChange={this.updateEntity}
                    disabled={formStatus.pending}
                    options={[
                      { label: 'Client', value: 'client' },
                      { label: 'Item', value: 'item' },
                      { label: 'Handover', value: 'handover' },
                      { label: 'Order', value: 'item_sales_order' },
                      { label: 'Order: car rent', value: 'car_rent_order' },
                      { label: 'Order: car sales', value: 'car_sales_order' },
                    ]}
                  />
                  <FormAutocomplete
                    name="event"
                    label={messages.event}
                    value={entity.getEvent()}
                    meta={entity.getEventMetaInformation()}
                    validation={entity.getEventValidationResult()}
                    onChange={this.updateEntity}
                    disabled={formStatus.pending}
                    options={[{ label: 'Create', value: 'create' }]}
                  />
                  <FormInput
                    name="endpoint"
                    label={messages.endpoint_url}
                    value={entity.getEndpoint()}
                    meta={entity.getEndpointMetaInformation()}
                    validation={entity.getEndpointValidationResult()}
                    onChange={this.updateEntity}
                    disabled={formStatus.pending}
                  />
                </div>

                <p class="p-t-15 form-group-title">{messages.authentication}</p>
                <div class="form-group-attached">
                  <Row>
                    <Col xs={6} class="form-group form-group-default">
                      <div class="radio radio-success p-l-15">
                        <input
                          id="authBasic"
                          disabled={formStatus.pending}
                          name="auth"
                          type="radio"
                          value={'basic'}
                          checked={entity.getAuth() === 'basic'}
                          onChange={e => this.updateEntity('auth', e.target.value)}
                        />
                        <label for={'authBasic'}>Basic</label>
                      </div>
                    </Col>
                    <Col xs={6} class="form-group form-group-default">
                      <div class="radio radio-success p-l-15">
                        <input
                          id="authNone"
                          disabled={formStatus.pending}
                          name="auth"
                          type="radio"
                          value={'none'}
                          checked={entity.getAuth() === 'none'}
                          onChange={e => this.updateEntity('auth', e.target.value)}
                        />
                        <label for={'authNone'}>{messages.none}</label>
                      </div>
                    </Col>
                  </Row>

                  {entity.getAuth() === 'basic' ? (
                    <Row>
                      <Col xs={12} sm={6}>
                        <FormInput
                          name="basicAuthUsername"
                          label={messages.username}
                          value={entity.getBasicAuthUsername()}
                          meta={entity.getBasicAuthUsernameMetaInformation()}
                          validation={entity.getBasicAuthUsernameValidationResult()}
                          onChange={this.updateEntity}
                          disabled={formStatus.pending}
                        />
                      </Col>
                      <Col xs={12} sm={6}>
                        <FormInputPassword
                          name="basicAuthPassword"
                          label={messages.password}
                          value={entity.getBasicAuthPassword()}
                          meta={entity.getBasicAuthPasswordMetaInformation()}
                          validation={entity.getBasicAuthPasswordValidationResult()}
                          onChange={this.updateEntity}
                          disabled={formStatus.pending}
                        />
                      </Col>
                    </Row>
                  ) : null}
                </div>

                <p class="p-t-15 form-group-title">{messages.headers}</p>
                <div class="form-group-attached">
                  <div class="form-group form-group-default">
                    <textarea
                      value={entity.getHeaders()}
                      name="headers"
                      onChange={e => this.updateEntity('headers', e.target.value)}
                      style={{ width: '100%' }}
                      rows={8}
                    />
                  </div>
                </div>

                <div class="text-right m-t-15">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    type="submit"
                    bsStyle={this.state.entityChanged ? 'primary' : 'default'}
                  >
                    <i class={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                    {messages.save}
                  </Button>
                </div>
              </div>
            </form>
          ) : (
            <Loader />
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DataPushForm)));
